import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SearchInput } from './SearchInput';
import { QuestionStatus, type QuestionSource } from '@/types';

interface FilterControlsProps {
  search?: string;
  status?: QuestionStatus[];
  source?: QuestionSource[];
  onSearchChange: (value: string) => void;
  onStatusChange: (value: QuestionStatus[]) => void;
  onSourceChange: (value: QuestionSource[]) => void;
  onReset: () => void;
  hasActiveFilters: boolean;
}

const statusOptions = [
  { value: QuestionStatus.PENDING, label: 'Pending' },
  { value: QuestionStatus.TRIAGED, label: 'Triaged' },
  { value: QuestionStatus.ASSIGNED, label: 'Assigned' },
  { value: QuestionStatus.ANSWERED, label: 'Answered' },
  { value: QuestionStatus.SENT, label: 'Sent' },
  { value: QuestionStatus.REJECTED, label: 'Rejected' },
];

const sourceOptions = [
  { value: 'extension', label: 'Extension' },
  { value: 'kai', label: 'Kai' },
  { value: 'web', label: 'Web' },
  { value: 'whatsapp', label: 'WhatsApp' },
];

export function FilterControls({
  search,
  status,
  source,
  onSearchChange,
  onStatusChange,
  onSourceChange,
  onReset,
  hasActiveFilters,
}: FilterControlsProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center">
      <div className="flex-1 md:max-w-sm">
        <SearchInput value={search} onChange={onSearchChange} />
      </div>

      <div className="flex w-full gap-2 sm:w-auto">
        <Select
          value={status?.[0] || ''}
          onValueChange={(value) =>
            onStatusChange(value ? [value as QuestionStatus] : [])
          }
        >
          <SelectTrigger className="w-full sm:w-[140px]">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            {statusOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select
          value={source?.[0] || ''}
          onValueChange={(value) =>
            onSourceChange(value ? [value as QuestionSource] : [])
          }
        >
          <SelectTrigger className="w-full sm:w-[140px]">
            <SelectValue placeholder="Source" />
          </SelectTrigger>
          <SelectContent>
            {sourceOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={onReset}>
            <X className="mr-1 h-4 w-4" />
            Clear
          </Button>
        )}
      </div>
    </div>
  );
}
